import { Injectable } from '@angular/core';
import { ClienteUnicoAppDto, PetDto , ClienteUnicoServiceProxy, ClienteUnicoDto, OrderDto} from './service-proxy/service-proxies';
import * as moment from 'moment';
import 'moment/locale/es'; // importar idioma español


@Injectable()
export class AppService {

    public idUnico? : string;
    public countryCode? : string;

    private cu_app_data = 'CU_APP_DATA';
    private cu_data = 'CU_DATA';
    private cuAppSession: ClienteUnicoAppDto | null | undefined = null;
    private cuSession:ClienteUnicoDto | null | undefined  = null;

    // Cache de ordenes POR PAGINA. Antes era una sola lista, pero Orders/GetOrders
    // ahora esta paginado y una cache global devolvia el contenido de otra pagina.
    private orders_pages = new Map<number, OrderDto[]>();
    private orders_paging : OrdersPaging | null = null;
    private orders_last_sync : Date | null | undefined  = null;


    private order?:OrderDto;

    constructor(clienteUnicoService: ClienteUnicoServiceProxy) {
      moment.locale('es');
    }

    saveOrder( dto : OrderDto ){
      this.order = dto;
    }

    getOrder( ){
      return this.order;
    }

    // Cliente Unico APP DATA
    saveClienteAppData(cuSession : ClienteUnicoAppDto) {
        this.cuAppSession = cuSession;
        sessionStorage.setItem(this.cu_app_data, JSON.stringify(cuSession) );
    }

    getClienteAppDataSession(idUnico : string) : ClienteUnicoAppDto | null {
        
      if(this.cuAppSession)
        return this.cuAppSession;
      return null;
    }

    getClienteAppData(idUnico : string) : ClienteUnicoAppDto | null {
        
        if(this.cuAppSession)
          return this.cuAppSession;

        else {
          const json = sessionStorage.getItem(this.cu_app_data);

          if(json){

              const data = JSON.parse(json);
              
              let cu = new ClienteUnicoAppDto();
              cu.init(data)

              if(cu.idUnico == idUnico){
                this.cuAppSession = cu;
                return cu;
              } 
          }
        }

        return null;
    }

    deleteClienteAppData() {
      this.cuAppSession = null;
      sessionStorage.removeItem(this.cu_app_data);
    }


    saveClienteUnicoData(cu : ClienteUnicoDto) {
        this.cuSession = cu;
        sessionStorage.setItem(this.cu_data, JSON.stringify(this.cuSession) );
    }


    getClienteData(idUnico : string) : ClienteUnicoDto | null {
        
        if(this.cuSession)
          return this.cuSession;

        else {
          const json = sessionStorage.getItem(this.cu_data);

          if(json){

              const data = JSON.parse(json);
              
              let cu = new ClienteUnicoDto();
              cu.init(data)

              if(cu.idUnico == idUnico){
                this.cuSession = cu;
                return cu;
              } 
          }
        }

        return null;
    }

    deleteClienteUnicoData() {
      this.cuSession = null;
      sessionStorage.removeItem(this.cu_data);
    }

    // ORDERS

    getOrdersData(pageIndex : number = 0)  {

      if(!this.hasLessThan30MinutesDifference()){
        this.clearOrdersData();
        return null;
      }

      const cached = this.orders_pages.get(pageIndex);

      return (cached && cached.length > 0) ? cached : null;
    }

    saveOrdersData(orders : OrderDto[], pageIndex : number = 0) {

      // La ventana de frescura arranca con la primera pagina que se carga, asi que
      // todas las paginas de una misma navegacion expiran juntas.
      if(!this.orders_last_sync)
        this.orders_last_sync = new Date();

      this.orders_pages.set(pageIndex, orders);
    }

    // Se cachea aparte de las paginas porque al volver del detalle el componente se
    // recrea: sin esto la pagina sale de cache pero los botones de paginado no
    // sabrian cuantas paginas hay.
    saveOrdersPaging(paging : OrdersPaging) {
      this.orders_paging = paging;
    }

    getOrdersPaging() : OrdersPaging | null {
      return this.hasLessThan30MinutesDifference() ? this.orders_paging : null;
    }

    clearOrdersData() {
      this.orders_pages.clear();
      this.orders_paging = null;
      this.orders_last_sync = null;
    }

    // UTILES

    hasLessThan30MinutesDifference(): boolean {

      const currentDate = new Date();
    
      // Verifica si orders_last_sync es null o undefined
      if (!this.orders_last_sync) {
        return false; 
      }
    
      // Calcula la diferencia en minutos entre orders_last_sync y la fecha actual
      const diffInMinutes = (currentDate.getTime() - this.orders_last_sync.getTime()) / (1000 * 60);
    
      // Comprueba si la diferencia es mayor a 30 minutos
      return diffInMinutes < 30;
    }

    selectImageForPet(pet : PetDto, forceGeneric : boolean = false) {

        if(!forceGeneric) {
          if(pet.pictureUrl)
            return pet.pictureUrl;
        }

        // evaluar la especie y mostrar imagen generica 
        if(pet.species.name == 'CANINO')
          return '../assets/images/dog.svg';

        if(pet.species.name == 'FELINO')
            return '../assets/images/cat.svg';

        if(pet.species.name == 'AVES' || pet.species.name == 'LORO' )
            return '../assets/images/bird.png';

        if(pet.species.name == 'ROEDOR' )
            return '../assets/images/rabbit.png';

        if(pet.species.name == 'PEZ')
            return '../assets/images/fish.png';

        return '../assets/images/puppis.png';
    }

    // calcularEdad(fechaNacimiento  : string) {

    //     const fechaActual = new Date();
    //     const fechaNac = new Date(fechaNacimiento);
    
    //     let edad = {
    //       años: fechaActual.getFullYear() - fechaNac.getFullYear(),
    //       meses: fechaActual.getMonth() - fechaNac.getMonth() 
    //     };
    
    //     if (fechaNac.getDate() > fechaActual.getDate()) {
    //       edad.meses--;
    //     }
    //     if (edad.meses < 0) {
    //       edad.años--;
    //       edad.meses = 12 + edad.meses;
    //     }
        
    //     return edad;
    // }

     calcularEdad(fechaNacimiento: string) {
      const fechaActual = new Date();
      const fechaNac = new Date(fechaNacimiento);
    
      let edad = {
        años: fechaActual.getFullYear() - fechaNac.getFullYear(),
        meses: fechaActual.getMonth() - fechaNac.getMonth(),
        dias: fechaActual.getDate() - fechaNac.getDate(),
      };
    
      if (fechaNac > fechaActual) {
        // Si la fecha de nacimiento es posterior a la fecha actual, ajustar la edad
        edad.años--;
        const ultimosMeses = 12 - fechaNac.getMonth();
        edad.meses = ultimosMeses + fechaActual.getMonth();
        const ultimoDiaDelMesNac = new Date(
          fechaNac.getFullYear(),
          fechaNac.getMonth() + 1,
          0
        ).getDate();
        edad.dias = ultimoDiaDelMesNac - fechaNac.getDate() + fechaActual.getDate();
      }
    
      if (edad.meses < 0) {
        edad.años--;
        edad.meses = 12 + edad.meses;
      }
    
      if (edad.dias < 0) {
        // Manejar el caso de los días negativos, restando 1 al mes
        edad.meses--;
        const ultimoDiaDelMesNac = new Date(
          fechaNac.getFullYear(),
          fechaNac.getMonth() + 1,
          0
        ).getDate();
        edad.dias = ultimoDiaDelMesNac - fechaNac.getDate() + fechaActual.getDate();
      }
    
      return edad;
    }

    calcularEdadString(edad: any) {

      let output = '';
      if(edad.años > 0) {

        if(edad.meses == 0)
          output =  `${edad.años} años de edad`;
        else
          output = `${edad.años} años y ${edad.meses} meses de edad`;

      }
      else {

        if(edad.meses > 0 )
            output = `${edad.meses} meses de edad`;
        else
            output =  `${edad.dias} días de edad`;
      }

      if(edad.años == 1)
      output=  output.replace('años','año');
      if(edad.meses == 1)
      output=output.replace('meses','mes');
      if(edad.dias == 1)
      output=output.replace('días','día');
     
      return output;
    }

    convertirFecha(fechaMoment: moment.Moment): string {
      
      var textDate = fechaMoment.format('dddd D [de] MMMM YYYY');

      return textDate.charAt(0).toUpperCase() + textDate.slice(1);
    }

    


    // si no tiene source COde ( todas entregadas)
      // SI es ICG, es tienda -->fecha de creacion,  direccion de entrega deberia venir la de la tienda en de delivery data
      // Si no es ICG, le ponemos CAllCenter -> fecha de creacion,  sin lugar  de entrega


    // si tiene sourceCode es OMS 
      // se entregara, fecha estimada From, lugar de delivery data
      // entregado, fecha deberia venir la del proveedor, lugar de delivery data
      // cancelada, > sin fecha, sin lugar  de entrega
      // no entregado > sin lugar  de entrega

    convertirLogisticStatus(order: OrderDto) : OrderStatus {

      // ORDENES ONLINE
      if(order.sourceName == 'Mercado Libre' || order.sourceName == 'vTex') {

        if(order.currentLogisticStatus == 'Delivered'){

          let entregado = !order?.deliveredOn ? 'Entregado' : `Entregado el ${ order?.deliveredOn?.format('DD/MM')}`;
          let status = new OrderStatus ('E', entregado);
          status.isDelivered = true;
          status.source = 'Online';
          return status;
        }
          
        if(order.currentLogisticStatus == 'NotDelivered'){
          
          let status = new OrderStatus ('X', `No Entregado`);
          status.isNotDelivered = true;
          status.source = 'Online';
          return status;
        }
       
        if(order.currentLogisticStatus == 'Cancelled'){
          
          let status = new OrderStatus ('X', `Cancelado`);
          status.isNotDelivered = true;
          status.source = 'Online';
          return status;
        }

        let estimated = order.deliveryData?.estimatedDeliveryDateFrom ? order.deliveryData?.estimatedDeliveryDateFrom?.format('DD/MM') : '- sin registro -';
        
        let status = new OrderStatus ('P', `Se entregará el ${ estimated }`);
        status.source = 'Online';
        return status;
      } 
      else {

        let status = new OrderStatus ('E', `Entregado el ${ order.sourceCreationTime.format('DD/MM')}`);
        status.isDelivered = true;

        if(order.sourceName == 'ICG') {
          var tienda = 'Tienda ' + order.currentAssignedToStoreName;
          status.source = tienda;
        }
          
          
        else if(order.sourceName == 'Telefonica' || order.sourceName == 'Whatsapp')
          status.source = 'Callcenter'; 

        else 
          status.source = order.sourceName;

        return status;
      }
      
     
  }

}


/** Paginacion de facturas que devuelve Orders/GetOrders. */
export interface OrdersPaging {
  pageIndex : number;
  totalPages : number;
  totalInvoices : number;
}


export class OrderStatus {

  statusCode : string ;
  statusName : string ;

  source? : string;

  isDelivered  = false;
  isNotDelivered = false;

  constructor(code: string, name : string){
    this.statusCode = code;
    this.statusName = name;
  }
}
